module.exports = "../../static/img/pie-black.21e300f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pie-black.png
// module id = 57
// module chunks = 0